import { types, Instance } from 'mobx-state-tree';

export const DocumentInfo = types
  .model({
    documentId: types.string, 
    caregiverId: types.string, 
    recipientId: types.string, 
    recipientName: types.optional(types.string, ''),
    domain: types.string, 
    tasks: types.optional(types.string, ''),
    fileName: types.string, 
    fileType: types.string, 
    fileSize: types.string, 
    uploadedOn: types.string, 
    lastModifiedOn: types.string
  })
  .views((self) => ({ }))
  .actions((self) => ({
    setDocumentId(documentId: string) {
      self.documentId = documentId;
    },
    setCaregiverId(caregiverId: string) {
      self.caregiverId = caregiverId;
    },
    setRecipientId(recipientId: string) {
      self.recipientId = recipientId;
    },
    setRecipientName(recipientName: string) {
      self.recipientName = recipientName;
    },
    setDomain(domain: string) {
      self.domain = domain;
    },
    setTasks(tasks: string) {
      self.tasks = tasks;
    },
    setFileName(fileName: string) {
      self.fileName = fileName;
    },
    setFileType(fileType: string) {
      self.fileType = fileType;
    },
    setFileSize(fileSize: string) {
      self.fileSize = fileSize;
    },
    setUploadedOn(uploadedOn: string) {
      self.uploadedOn = uploadedOn;
    },
    setLastModifiedOn(lastModifiedOn: string) {
      self.lastModifiedOn = lastModifiedOn;
    }
  }));

export default DocumentInfo;

export interface IDocumentInfo extends Instance<typeof DocumentInfo> { }
